import * as Types from '../../../__generated__/types.gqlgenerated';

import { gql } from '@apollo/client';
import { JobSeekerProfileFragmentDoc } from '../utils/__generated__/jobSeekerProfile.gqlgenerated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ViewjobQueryVariables = Types.Exact<{
  input: Types.Scalars['ID']['input'];
  detailsInput: Types.ViewJobDetailsInput;
  jobResultTrackingKey?: Types.InputMaybe<Types.Scalars['String']['input']>;
  isLoggedIn: Types.Scalars['Boolean']['input'];
  enableEmployerInsights: Types.Scalars['Boolean']['input'];
  shouldQueryBrandingEligibility: Types.Scalars['Boolean']['input'];
  commuteFrom?: Types.CommuteLocationInput;
  commuteMethod?: Types.CommuteMethod;
  includeCommute?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
}>;


export type ViewjobQuery = { __typename?: 'Query', viewjob?: { __typename?: 'ViewJob', key: string, job?: { __typename?: 'Job', key: string, sourceEmployerName: string, title: string, expired: boolean, language: string, datePublished: number, description: { __typename?: 'JobDescription', text: string }, occupations: Array<{ __typename?: 'JobOccupation', key: string }>, attributes: Array<{ __typename?: 'JobAttribute', label: string }>, location: { __typename?: 'JobLocation', countryCode: string, latitude: number, longitude: number, formatted: { __typename?: 'FormattedJobLocation', long: string } }, employer?: { __typename?: 'Employer', key: string, subsidiaryOptOutStatusV2?: boolean | null, ugcStats?: { __typename?: 'JobseekerUgcStats', globalReviewCount?: number | null, ratings?: { __typename?: 'RatingBundle', overallRating?: { __typename?: 'AverageRating', value?: number | null, count?: number | null } | null } | null } | null, parentEmployer?: { __typename?: 'Employer', name?: string | null, subsidiaryOptOutStatusV2?: boolean | null } | null, dossier?: { __typename?: 'EmployerDossier', images?: { __typename?: 'ImageBundle', rectangularLogoUrl?: string | null, headerImageUrls?: { __typename?: 'HeaderImageUrlBundle', url1960x400: string } | null, squareLogoUrls?: { __typename?: 'SquareLogoUrlBundle', url256: string } | null } | null, headerAltText?: { __typename?: 'EmployerHeaderText', value?: string | null } | null } | null } | null, compensation?: { __typename?: 'JobCompensation', formattedText?: string | null, currencyCode?: string | null, baseSalary?: { __typename?: 'Salary', unitOfWork?: Types.UnitOfWork | null, range?: { __typename?: 'AtLeast', min: number } | { __typename?: 'AtMost', max: number } | { __typename?: 'Exactly', value: number } | { __typename?: 'Range', min: number, max: number } | null } | null } | null, indeedApply: { __typename?: 'JobIndeedApplyAttributes', key?: string | null, scopes: Array<Types.JobIndeedApplyScope> }, jobseekerPreferences?: { __typename?: 'JobseekerPreferences', paySentiment?: Types.JobSeekerSentiment | null, knownPreferenceIds: Array<{ __typename?: 'KnownUserSentimentIdEntry', id?: string | null, suid?: string | null }>, minimumPayPreferences: Array<{ __typename?: 'UserMinimumPayPreference', payAmount?: number | null, salaryType?: string | null }> } | null, applicants?: { __typename?: 'Applicants', hasInsights: boolean, count: { __typename?: 'ApplicantsCount', total: number, last24h: number }, workExperience: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, education: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, skills: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, certificates: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, previewInsight?: { __typename?: 'QualificationDemographic', title: string, pct: number } | null } | null, source?: { __typename?: 'JobSource', responsiveness?: { __typename?: 'JobSourceResponsiveness', averageResponseTimeDays?: number | null, responseRate?: number | null, isActivelyReviewed: boolean, lastActivityTimeInDays?: number | null } | null }, brandingEligibility?: { __typename?: 'BrandingEligibilityForJob', shouldShowBranding?: boolean | null, brandingInformation?: { __typename?: 'BrandingInformation', localizedAssets?: { __typename?: 'BrandingLocalizedAssets', logo?: { __typename?: 'LocalizedImageAsset', url: string } | null, banner?: { __typename?: 'LocalizedImageAsset', url: string } | null } | null } | null, brandingAttribution: Array<{ __typename?: 'BrandingAttribution', sourceType: string }> } | null, commute?: { __typename?: 'JobCommute', durationMinutes: number } | null } | null, details?: { __typename?: 'ViewJobDetails', mobvjtk: string, proctorGroups: string, companySummary?: string | null, iaApplied?: boolean | null, isApplyRateLimited: boolean, ctaEnticer?: string | null, disclaimerText?: string | null, isBrandedJob: boolean, isCompanyTabActive?: boolean | null, sanitizedJobDescription: string, trueJobLocation?: string | null, isSponsored: boolean, shouldDisplayCompetitorsJobs: boolean, companyLinks?: { __typename?: 'ViewJobCompanyLinks', companyOverviewLink?: string | null, companyReviewLink?: string | null } | null, reportContent: { __typename?: 'ViewJobReportContent', contentReportData: string, apiUrl: string }, location: { __typename?: 'ViewJobLocation', formattedStreetAddress?: string | null }, profile: { __typename?: 'ViewJobProfile', isProfileInsightsBlocked: boolean }, userPreference: { __typename?: 'ViewJobUserPreference', highlightedAttributes: Array<{ __typename?: 'ViewJobHighlightedAttributes', label?: string | null, highlightedAttributes?: Array<string | null> | null, highlightedAttributesIds?: Array<string | null> | null, tooltips?: Array<{ __typename?: 'ViewJobTooltip', attribute?: string | null, tooltipText?: string | null, isTooltipActive?: boolean | null } | null> | null }>, jobDescriptionSectionedContentMap: Array<{ __typename?: 'DescriptionSectionedContentMapTuple', contentKey: string, contentValue: Array<string> }>, matchedShift: Array<{ __typename?: 'JobDetailsPreference', label?: string | null, sentiment?: string | null, suid?: string | null, customClassSuids?: Array<string | null> | null, customClassLabels?: Array<string | null> | null }>, matchedJobTypes: Array<{ __typename?: 'JobDetailsPreference', suid?: string | null, customClassLabels?: Array<string | null> | null, customClassSuids?: Array<string | null> | null, label?: string | null, sentiment?: string | null }>, matchedSegmentPreferences?: Array<{ __typename?: 'ViewJobSegmentPreference', displayTitle?: string | null, attributes?: Array<{ __typename?: 'ViewJobSegmentPreferenceAttribute', suid?: string | null, label?: string | null, sentiment?: Types.Sentiment | null } | null> | null } | null> | null }, applyMethod?: { __typename?: 'ViewJobHiringEvent', content: string, indeedApplyUrl: string } | { __typename?: 'ViewJobIndeedApply', contentHtml: string, continueUrl: string, additionalUrlParameters: string, clientMeta?: string | null, isApplyPlusRsvpEnabled: boolean, tmnUrl?: string | null } | { __typename?: 'ViewJobThirdPartyApply', applyUrl: string, content: string, appShareUrl: string } | null, remoteWorkModel?: { __typename?: 'ViewJobRemoteWorkModel', text: string, isInlineText: boolean, type: Types.ViewJobRemoteWorkType } | null, benefit: { __typename?: 'JobBenefitsModel', benefitsCollapseThreshold: number, benefits?: Array<{ __typename?: 'JobBenefit', key: string, label: string }> | null }, interviewNowModel?: { __typename?: 'InterviewNowModel', InterviewerCount?: number | null, existingApplicantUrl?: string | null } | null, salaryInfo?: { __typename?: 'ViewJobSalaryInfo', max: number, min: number } | null, jobTypeAndShiftSchedule?: { __typename?: 'ViewJobJobTypeAndShiftSchedule', jobTypes?: Array<string> | null, shiftAndSchedule?: Array<string> | null } | null } | null } | null, jobSeekerProfile?: { __typename?: 'JobSeekerProfilePayload', profile?: { __typename?: 'JobSeekerProfile', accountKey?: string | null, defaultInfo?: { __typename?: 'JobSeekerProfileDefaultInfo', contactInformation?: { __typename?: 'JobSeekerProfileContactInformation', location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, address2?: string | null, admin1?: string | null, admin2?: string | null, admin3?: string | null, admin4?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, fullFormattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null } | null } | null, resume: Array<{ __typename?: 'JobSeekerProfileResume', id: string, location?: { __typename?: 'JobSeekerProfileLocationType', address?: string | null, address2?: string | null, admin1?: string | null, admin2?: string | null, admin3?: string | null, admin4?: string | null, city?: string | null, country?: string | null, state?: string | null, postalCode?: string | null, formattedLocation?: string | null, fullFormattedLocation?: string | null, latitude?: number | null, longitude?: number | null, geocodePrecision?: Types.JobSeekerProfileGeocodePrecision | null } | null }>, subscription?: { __typename?: 'JobSeekerProfileSubscription', status?: Types.JobSeekerProfileSubscriptionStatus | null } | null, jsProPremiumAccess?: { __typename?: 'JsProPremiumAccess', applicantInsights?: { __typename?: 'JsProPremiumAccessResult', access?: Types.JsProPremiumAccessStatus | null } | null } | null } | null } | null, jobSeekerProfileStructuredData?: { __typename?: 'JobSeekerProfileStructuredDataPayload', preferences: Array<{ __typename?: 'JobSeekerProfileStructuredDataPreference', id?: string | null, maximumCommute?: { __typename?: 'JobSeekerProfileStructuredDataCommute', timeMinutes?: number | null } | null }> } | null };

export type ApplicantDemographicsFieldsFragment = { __typename?: 'Applicants', count: { __typename?: 'ApplicantsCount', total: number, last24h: number }, workExperience: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, education: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, skills: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, certificates: Array<{ __typename?: 'QualificationDemographic', title: string, pct: number } | null>, previewInsight?: { __typename?: 'QualificationDemographic', title: string, pct: number } | null };

export const ApplicantDemographicsFieldsFragmentDoc = gql`
    fragment ApplicantDemographicsFields on Applicants {
  count {
    total
    last24h
  }
  workExperience {
    title
    pct
  }
  education {
    title
    pct
  }
  skills {
    title
    pct
  }
  certificates {
    title
    pct
  }
  previewInsight {
    title
    pct
  }
}
    `;
export const ViewjobDocument = gql`
    query Viewjob($input: ID!, $detailsInput: ViewJobDetailsInput!, $jobResultTrackingKey: String, $isLoggedIn: Boolean!, $enableEmployerInsights: Boolean!, $shouldQueryBrandingEligibility: Boolean!, $commuteFrom: CommuteLocationInput! = {latitude: 0, longitude: 0}, $commuteMethod: CommuteMethod! = AUTOMOBILE_NO_TRAFFIC, $includeCommute: Boolean = false) {
  viewjob(input: $input, jobResultTrackingKey: $jobResultTrackingKey) {
    key
    job {
      key
      sourceEmployerName
      title
      description {
        text
      }
      expired
      language
      datePublished
      occupations {
        key
      }
      attributes {
        label
      }
      location {
        countryCode
        formatted {
          long
        }
        latitude
        longitude
      }
      employer {
        key
        ugcStats {
          globalReviewCount
          ratings {
            overallRating {
              value
              count
            }
          }
        }
        subsidiaryOptOutStatusV2
        parentEmployer {
          name
          subsidiaryOptOutStatusV2
        }
        dossier {
          images {
            rectangularLogoUrl
            headerImageUrls {
              url1960x400
            }
            squareLogoUrls {
              url256
            }
          }
          headerAltText {
            value
          }
        }
      }
      compensation {
        formattedText
        currencyCode
        baseSalary {
          unitOfWork
          range {
            ... on Range {
              min
              max
            }
            ... on Exactly {
              value
            }
            ... on AtLeast {
              min
            }
            ... on AtMost {
              max
            }
          }
        }
      }
      indeedApply {
        key
        scopes
      }
      jobseekerPreferences {
        knownPreferenceIds {
          id
          suid
        }
        paySentiment
        minimumPayPreferences {
          payAmount
          salaryType
        }
      }
      applicants @include(if: $isLoggedIn) {
        hasInsights
        ...ApplicantDemographicsFields
      }
      source @include(if: $enableEmployerInsights) {
        responsiveness {
          averageResponseTimeDays
          responseRate
          isActivelyReviewed
          lastActivityTimeInDays
        }
      }
      brandingEligibility(input: {requestSource: VIEW_JOB}) @include(if: $shouldQueryBrandingEligibility) {
        shouldShowBranding
        brandingInformation {
          localizedAssets {
            logo {
              url
            }
            banner {
              url
            }
          }
        }
        brandingAttribution {
          sourceType
        }
      }
      commute(from: $commuteFrom, method: $commuteMethod) @include(if: $includeCommute) {
        durationMinutes
      }
    }
    details(input: $detailsInput) {
      mobvjtk
      proctorGroups
      companySummary
      iaApplied
      isApplyRateLimited
      ctaEnticer
      disclaimerText
      isBrandedJob
      isCompanyTabActive
      companyLinks {
        companyOverviewLink
        companyReviewLink
      }
      sanitizedJobDescription
      reportContent {
        contentReportData
        apiUrl
      }
      location {
        formattedStreetAddress
      }
      trueJobLocation
      profile {
        isProfileInsightsBlocked
      }
      userPreference {
        highlightedAttributes {
          label
          highlightedAttributes
          highlightedAttributesIds
          tooltips {
            attribute
            tooltipText
            isTooltipActive
          }
        }
        jobDescriptionSectionedContentMap {
          contentKey
          contentValue
        }
        matchedShift {
          label
          sentiment
          suid
          customClassSuids
          customClassLabels
        }
        matchedJobTypes {
          suid
          customClassLabels
          customClassSuids
          label
          sentiment
        }
        matchedSegmentPreferences {
          displayTitle
          attributes {
            suid
            label
            sentiment
          }
        }
      }
      applyMethod {
        ... on ViewJobIndeedApply {
          contentHtml
          continueUrl
          additionalUrlParameters
          clientMeta
          isApplyPlusRsvpEnabled
          tmnUrl
        }
        ... on ViewJobThirdPartyApply {
          applyUrl
          content
          appShareUrl
        }
        ... on ViewJobHiringEvent {
          content
          indeedApplyUrl
        }
      }
      remoteWorkModel {
        text
        isInlineText
        type
      }
      benefit {
        benefits {
          key
          label
        }
        benefitsCollapseThreshold
      }
      isSponsored
      mobvjtk
      shouldDisplayCompetitorsJobs
      interviewNowModel {
        InterviewerCount
        existingApplicantUrl
      }
      salaryInfo {
        max
        min
      }
      jobTypeAndShiftSchedule {
        jobTypes
        shiftAndSchedule
      }
    }
  }
  jobSeekerProfile @include(if: $isLoggedIn) {
    ...JobSeekerProfile
  }
  jobSeekerProfileStructuredData(
    input: {queryFilter: {dataCategories: [CONFIRMED_BY_USER]}}
  ) @include(if: $isLoggedIn) {
    preferences {
      id
      maximumCommute {
        timeMinutes
      }
    }
  }
}
    ${ApplicantDemographicsFieldsFragmentDoc}
${JobSeekerProfileFragmentDoc}`;

/**
 * __useViewjobQuery__
 *
 * To run a query within a React component, call `useViewjobQuery` and pass it any options that fit your needs.
 * When your component renders, `useViewjobQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useViewjobQuery({
 *   variables: {
 *      input: // value for 'input'
 *      detailsInput: // value for 'detailsInput'
 *      jobResultTrackingKey: // value for 'jobResultTrackingKey'
 *      isLoggedIn: // value for 'isLoggedIn'
 *      enableEmployerInsights: // value for 'enableEmployerInsights'
 *      shouldQueryBrandingEligibility: // value for 'shouldQueryBrandingEligibility'
 *      commuteFrom: // value for 'commuteFrom'
 *      commuteMethod: // value for 'commuteMethod'
 *      includeCommute: // value for 'includeCommute'
 *   },
 * });
 */
export function useViewjobQuery(baseOptions: Apollo.QueryHookOptions<ViewjobQuery, ViewjobQueryVariables> & ({ variables: ViewjobQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ViewjobQuery, ViewjobQueryVariables>(ViewjobDocument, options);
      }
export function useViewjobLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ViewjobQuery, ViewjobQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ViewjobQuery, ViewjobQueryVariables>(ViewjobDocument, options);
        }
export function useViewjobSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ViewjobQuery, ViewjobQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ViewjobQuery, ViewjobQueryVariables>(ViewjobDocument, options);
        }
export type ViewjobQueryHookResult = ReturnType<typeof useViewjobQuery>;
export type ViewjobLazyQueryHookResult = ReturnType<typeof useViewjobLazyQuery>;
export type ViewjobSuspenseQueryHookResult = ReturnType<typeof useViewjobSuspenseQuery>;
export type ViewjobQueryResult = Apollo.QueryResult<ViewjobQuery, ViewjobQueryVariables>;